import {useIntl} from 'react-intl'
import {Table} from 'src/feature/bite/component/Table'
import {getDateAndTime} from 'src/feature/bite/helpers/date'
import {useTerminal} from '../../hook'

const TerminalList = ({loading}: {loading: boolean}) => {
  const intl = useIntl()
  const {list, listFilter, listFilterSet} = useTerminal()

  const columns = [
    {
      key: 'id',
      dataIndex: 'terminalId',
      title: intl.formatMessage({id: 'TERMINAL.LIST.TERMINAL_ID'}),
    },
    {
      key: 'typeID',
      dataIndex: 'typeID',
      title: intl.formatMessage({id: 'TERMINAL.LIST.TERMINAL_TYPE'}),
      render: (type: any) => {
        switch (type) {
          case 0:
            return <>Main</>
          default:
            return <>{type}</>
        }
      },
    },
    {
      key: 'status',
      dataIndex: 'statusID',
      title: intl.formatMessage({id: 'TERMINAL.LIST.STATUS'}),
      status: true,
    },
    {
      key: 'loyaltyStatusID',
      dataIndex: 'loyaltyStatusID',
      title: intl.formatMessage({id: 'TERMINAL.LIST.LOYALTY_STATUS'}),
      status: true,
    },
    {
      key: 'lastTRXDate',
      dataIndex: 'lastTrxDate',
      title: intl.formatMessage({id: 'TERMINAL.LIST.LAST_TRX_DATE'}),
      render: (text: string) => <>{getDateAndTime(text)}</>,
    },
    {
      key: 'action',
      dataIndex: 'terminalId',
      title: intl.formatMessage({id: 'TERMINAL.LIST.ACTION'}),
      render: (id: string) => (
        <a href={`/terminals/${id}`}>{intl.formatMessage({id: 'TERMINAL.LIST.DETAIL'})}</a>
      ),
    },
  ]

  return (
    <Table
      loading={loading}
      dataSource={list.dataList}
      columns={columns}
      tableName={'terminals'}
      pagination={{
        current: list.paging.currentPageNumber,
        pageSize: list.paging.pageSize,
        total: list.paging.totalCount,
        onChange: (page: any) => {
          const {pageSize, current} = page
          const currentPage = pageSize !== listFilter.paging.pageSize ? 1 : current

          listFilterSet({
            ...listFilter,
            paging: {
              ...listFilter.paging,
              pageSize,
              currentPageNumber: currentPage,
            },
          })
        },
      }}
    />
  )
}

export default TerminalList
